import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Product } from '../product/types';
import { favoritesService } from './favoritesService';
import ProductCard from '../../components/ProductCard';

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState<Product[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const loadFavorites = async () => {
      try {
        setLoading(true);
        setError(null);
        const response = await favoritesService.getFavorites();
        setFavorites(response.products);
      } catch (err) {
        console.error('Failed to load favorites:', err);
        setError('Не удалось загрузить избранное');
      } finally {
        setLoading(false);
      }
    };

    loadFavorites();
  }, []);

  const handleRemoveFavorite = async (productId: number) => {
    try {
      await favoritesService.remove(productId);
      setFavorites((current) => current.filter((product) => product.id !== productId));
    } catch (err) {
      console.error('Failed to remove favorite:', err);
      setError('Не удалось обновить избранное');
    }
  };

  return (
    <div className="min-h-screen overflow-x-hidden bg-background px-4 py-6 text-foreground sm:py-8">
      <div className="mx-auto flex max-w-[90rem] flex-col gap-6">

        <h1 className="text-2xl font-semibold text-foreground sm:text-3xl">Избранное</h1>

        {error && (
          <div className="rounded-3xl border border-red-500/30 bg-red-500/10 p-4 text-sm text-red-700 dark:text-red-200">
            {error}
          </div>
        )}

        {loading ? (
          <div className="grid grid-cols-2 gap-3 sm:gap-[18px] md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            {Array.from({ length: 6 }).map((_, i) => (
              <div key={i} className="aspect-[5/6] animate-pulse rounded-[20px] bg-foreground/5 sm:rounded-[28px]" />
            ))}
          </div>
        ) : favorites.length === 0 ? (
          <div className="rounded-[32px] border border-foreground/10 bg-foreground/5 p-6">
            <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
              <div>
                <h2 className="text-lg font-medium text-foreground">Пока список пуст</h2>
                <p className="mt-2 text-sm text-foreground/60">
                  Добавьте товары в избранное на карточке продукта, и они появятся на этой странице.
                </p>
              </div>

              <Link
                to="/catalog"
                className="inline-flex items-center justify-center rounded-full border border-red-500 px-5 py-3 text-sm font-medium text-red-600 transition-colors hover:bg-red-500 hover:text-white dark:text-red-400"
              >
                Перейти в каталог
              </Link>
            </div>
          </div>
        ) : (
          <div className="grid grid-cols-2 gap-3 sm:gap-[18px] md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
            {favorites.map((product) => (
              <div key={product.id} className="flex flex-col gap-2">
                <ProductCard product={product} />
                <button
                  type="button"
                  onClick={() => handleRemoveFavorite(product.id)}
                  className="w-full rounded-2xl border border-red-500/40 py-2 text-sm font-medium text-red-600 transition-colors hover:bg-red-500 hover:text-white dark:text-red-400"
                >
                  Удалить
                </button>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
